import { RefObject, useRef, useState } from 'react';

type UseAuthModalReturn = [
    isAuthModalShowing: boolean,
    openAuthModal: (trigger: RefObject<HTMLElement> | null) => void,
    closeAuthModal: () => void
];

export const useAuthModal = (): UseAuthModalReturn => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const currentTargetRef = useRef<HTMLElement | null>(null);

    const openAuthModal = (trigger: RefObject<HTMLElement> | null) => {
        const fallbackFocusTarget =
            document.activeElement instanceof HTMLElement
                ? document.activeElement
                : null;

        currentTargetRef.current = trigger?.current || fallbackFocusTarget;

        setIsModalOpen(true);
    };

    const closeAuthModal = () => {
        setIsModalOpen(false);

        setTimeout(() => {
            currentTargetRef.current?.focus?.();
        }, 200);
    };

    return [isModalOpen, openAuthModal, closeAuthModal];
};
